import MotionNavLink from '../../MotionLink';
import { motion } from 'framer-motion';
const GetInTouch = () => {
  return (
    <section
      className="get-in-touch bg-color-after-secondary overlay overlay-color-primary overlay-show p-relative overflow-hidden"
      style={{
        backgroundImage: "url('img/demos/digital-agency-2/bg/bg-2.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <motion.span
        className="custom-circle custom-circle-1 bg-color-light"
        initial={{ scale: 0 }}
        whileInView={{ scale: 1 }}
        viewport={{ once: false, amount: 0.2 }}
        transition={{ duration: 0.5, delay: 0.1 }}
      ></motion.span>
      <motion.span
        className="custom-circle custom-circle-2 bg-color-light"
        initial={{ scale: 0 }}
        whileInView={{ scale: 1 }}
        viewport={{ once: false, amount: 0.2 }}
        transition={{ duration: 0.5, delay: 0.1 }}
      ></motion.span>
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <motion.p
              className="mb-2 text-color-tertiary custom-text-7 custom-title-with-icon custom-title-with-icon-light"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: false, amount: 0.2 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              Let’s Get in Touch
            </motion.p>
            <motion.h4
              className="text-color-light font-weight-bold custom-text-10"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: false, amount: 0.2 }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              We’re excited to
              <br />
              innovate with you using AI.
            </motion.h4>
          </div>
          <div className="col-lg-4 d-flex align-items-center justify-content-start justify-content-lg-end mt-5 mt-lg-0">
            <MotionNavLink
              to="/contact-us"
              className="btn btn-outline custom-btn-outline btn-light border-white rounded-0 px-4 py-3 text-color-light text-color-hover-dark bg-color-hover-light custom-text-6 line-height-6 font-weight-semibold custom-btn-with-arrow"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: false, amount: 0.2 }}
              transition={{ duration: 0.6, delay: 0.6 }}
            >
              Let’s Talk!
            </MotionNavLink>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetInTouch;
